export default "__VITE_ASSET__BLu0jKYy__"